import type { Priority, PriorityOnServer } from './ui/types';

type CalculateRowsOnPageParams = {
	rowsPerPage: number;
	selectedPage: number;
	totalRows: number;
};

export const calculateRowsOnPage = ({
	rowsPerPage,
	selectedPage,
	totalRows,
}: CalculateRowsOnPageParams) => {
	let startRow;
	let endRow;

	const isLastPage = totalRows < (selectedPage + 1) * rowsPerPage;

	if (selectedPage === 1) {
		startRow = selectedPage;
		endRow = totalRows <= rowsPerPage ? totalRows : rowsPerPage;
	} else {
		startRow = (selectedPage - 1) * rowsPerPage + 1;
		endRow = isLastPage ? totalRows : selectedPage * rowsPerPage;
	}

	return { startRow, endRow };
};

/**
 * @param obj Priority on server also returns a "isDefault" boolean field
 * however for mappings this field is not used and not consistently being
 * returned for getSuggestedMappings so for now when not returned we will
 * set isDefault as false.
 * @returns
 */
export const refinePriorityOnServer = (obj: unknown): PriorityOnServer | undefined => {
	if (!obj || typeof obj !== 'object') return undefined;

	if (!('self' in obj) || typeof obj.self !== 'string') return undefined;

	if (!('statusColor' in obj) || typeof obj.statusColor !== 'string') return undefined;

	if (!('description' in obj) || typeof obj.description !== 'string') return undefined;

	if (!('iconUrl' in obj) || typeof obj.iconUrl !== 'string') return undefined;

	if (!('name' in obj) || typeof obj.name !== 'string') return undefined;

	if (!('id' in obj) || typeof obj.id !== 'string') return undefined;

	if (!('sequence' in obj) || typeof obj.sequence !== 'string') return undefined;

	let isDefault = false;
	if ('isDefault' in obj && typeof obj.isDefault === 'boolean') {
		isDefault = obj.isDefault;
	}

	return {
		self: obj.self,
		statusColor: obj.statusColor,
		description: obj.description,
		iconUrl: obj.iconUrl,
		name: obj.name,
		id: obj.id,
		sequence: obj.sequence,
		isDefault,
	};
};

export const parsePriorityOnServerToPriority = (priorityOnServer: PriorityOnServer): Priority => ({
	...priorityOnServer,
	sequence: Number(priorityOnServer.sequence),
});
